import ArgumentLabel from '../arguments/ArgumentLabel.jsx';
import ArgumentWrapper from '../arguments/ArgumentWrapper.jsx';
import Input from '../Input.jsx';

const PanelInput = ({ label, icon, description, valid, helpIconContext, required, labelProps = {}, inputProps = {}, ...props }) => {
  // Remove label and description from props passed to Input since ArgumentLabel handles them
  const { label: _, description: __, ...inputPropsToPass } = props;

  return (
    <ArgumentWrapper className="simple-arguments">
      <ArgumentLabel className="small-gap" label={label} icon={icon} description={description} valid={valid} helpIconContext={helpIconContext} isRequired={required} {...labelProps} />
      <Input {...inputPropsToPass} {...inputProps} />
    </ArgumentWrapper>
  );
};

export default PanelInput;
